import React, { useState, useEffect, useRef } from "react";
// utils
import formatMoney from "lib/formatMoney";
// mui
import { useTheme } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import StackItem from "components/Loans/StackItem";
import Box from "@mui/material/Box";

const bridgeInterestRate = 12;

export default function SpreadLTVTable({ spreadQuoteData, processSelect }) {
  const theme = useTheme();
  const [loanType, setLoanType] = useState("");
  const [outputLtvRanges, setOutputLtvRanges] = useState("");
  const [rows, setRows] = useState("");
  const [portfolioLoan, setPortfolioLoan] = useState("");
  const [loanPurpose, setLoanPurpose] = useState("");
  const [creditScore, setCreditScore] = useState("");

  useEffect(() => {
    const loanType = "DSCR";
    setLoanType(loanType);

    // switch (loanType) {
    // case "DSCR":
    // const portfolioLoan = answers.filter((answer) => {
    //   return answer.q_title === "Portfolio loan";
    // })?.[0].a_string;
    // // Determine what to use as the base
    // // for property value
    // // purchase price vs as-is value for refinance vs purchase
    // const loanPurpose = answers?.filter((answer) => {
    //   return answer.q_title === "Loan purpose";
    // })?.[0]?.a_string;

    // const creditScore = answers?.filter((answer) => {
    //   return answer.q_title === "Credit score";
    // })?.[0]?.a_string;
    // setPortfolioLoan(portfolioLoan);
    // setLoanPurpose(loanPurpose);
    // setCreditScore(creditScore);

    let ltvRanges = [
      { title: "0-5", maxValue: 5 },
      { title: "5-10", maxValue: 10 },
      { title: "10-15", maxValue: 15 },
      { title: "15-20", maxValue: 20 },
      { title: "20-25", maxValue: 25 },
      { title: "25-30", maxValue: 30 },
      { title: "30-35", maxValue: 35 },
      { title: "35-40", maxValue: 40 },
      { title: "40-45", maxValue: 45 },
      { title: "45-50", maxValue: 50 },
      { title: "50-55", maxValue: 55 },
      { title: "55-60", maxValue: 60 },
    ];

    // switch (loanPurpose) {
    //   case "Refinance":
    //     if (creditScore < 700) {
    //       // 680 - 699	65%
    //       ltvRanges.push({ title: "61-65", maxValue: 65 });
    //     } else if (creditScore < 720) {
    //       // 700 - 719	70%
    //       ltvRanges.push({ title: "61-65", maxValue: 65 });
    //       ltvRanges.push({ title: "66-70", maxValue: 70 });
    //     } else {
    //       // 720+	75%
    //       ltvRanges.push({ title: "61-65", maxValue: 65 });
    //       ltvRanges.push({ title: "66-70", maxValue: 70 });
    //       ltvRanges.push({ title: "71-75", maxValue: 75 });
    //     }

    //     break;
    //   case "Purchase":
    //     if (creditScore < 700) {
    //       // 680 - 699	70%
    //       ltvRanges.push({ title: "61-65", maxValue: 65 });
    //       ltvRanges.push({ title: "66-70", maxValue: 70 });
    //     } else if (creditScore < 720) {
    //       // 700 - 719	75%
    //       ltvRanges.push({ title: "61-65", maxValue: 65 });
    //       ltvRanges.push({ title: "66-70", maxValue: 70 });
    //       ltvRanges.push({ title: "71-75", maxValue: 75 });
    //     } else {
    //       // 720+	80%
    //       ltvRanges.push({ title: "61-65", maxValue: 65 });
    //       ltvRanges.push({ title: "66-70", maxValue: 70 });
    //       ltvRanges.push({ title: "71-75", maxValue: 75 });
    //       ltvRanges.push({ title: "76-80", maxValue: 80 });
    //     }

    //     break;
    // }

    let rows = [{ name: "Treasury" }, { name: "Spread" }, { name: "My rate" }];

    let outputLtvRanges = [];
    // build up rows object with incoming data

    Object.keys(spreadQuoteData.LTVObj).forEach((key) => {
      if (!isNaN(parseInt(key))) {
        const maxValue = key;

        outputLtvRanges.push({ maxValue: key });

        rows.forEach((row) => {
          switch (row.name) {
            case "Treasury":
              row[maxValue] = `${parseFloat(
                spreadQuoteData.treasury5yr.rate
              ).toFixed(2)}%`;
              break;
            case "Spread":
              row[maxValue] = `${
                spreadQuoteData.LTVObj[maxValue]["creditSpread"] &&
                `${parseFloat(
                  spreadQuoteData.LTVObj[maxValue]["creditSpread"]
                ).toFixed(2)}%`
              }`;
              break;
            case "My rate":
              row[maxValue] = `${(
                parseFloat(spreadQuoteData.LTVObj[maxValue]["creditSpread"]) +
                parseFloat(spreadQuoteData.treasury5yr.rate)
              ).toFixed(2)}%`;
              break;
          }
        });
      }
    });

    setRows(rows);

    // undoing this because at some point this was requested
    // so flipping it back
    outputLtvRanges = outputLtvRanges.reverse();

    setOutputLtvRanges(outputLtvRanges);
  }, [spreadQuoteData]);

  return [
    loanType === "DSCR" && (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead sx={{}}>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  fontWeight: 600,
                  color: "white !important",
                }}
              >
                LTV
              </TableCell>
              {outputLtvRanges.map((LTV) => {
                return (
                  <TableCell
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      fontWeight: 600,
                      color: "white !important",
                    }}
                    align="center"
                  >
                    {` ${LTV.maxValue}%`}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                {outputLtvRanges.map((ltvRange) => {
                  const ltvMaxValue = ltvRange.maxValue;

                  return (
                    <TableCell
                      sx={{ textAlign: "center" }}
                      component="th"
                      scope="row"
                    >
                      {row[ltvMaxValue]}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}

            <TableRow
              key={"loan_ltv_picker_row"}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                Choose your rate
              </TableCell>
              {outputLtvRanges.map((ltvRange) => {
                const ltvMaxValue = ltvRange.maxValue;

                const [interestRateRow] = rows.filter((row) => {
                  return row.name === "My rate";
                });

                return (
                  <TableCell
                    sx={{ textAlign: "center" }}
                    component="th"
                    scope="row"
                  >
                    {!["Below min loan", "DSCR too low"].includes(
                      //this works for now since we only have 1 product
                      interestRateRow[ltvMaxValue]
                    ) && (
                      <Button
                        sx={{
                          color: "white !important",
                          "&:hover, :focus": {
                            color: `${theme.palette.primary.contrastColor} !important`,
                            backgroundColor: `${theme.palette.success.dark} !important`,
                          },
                        }}
                        variant="contained"
                        onClick={() => {
                          // custom select function

                          processSelect({
                            ...spreadQuoteData.LTVObj[ltvRange.maxValue],
                            LTV: ltvRange.maxValue,
                          });
                        }}
                      >
                        Select
                      </Button>
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    ),
  ];
}
